import { z } from 'zod';

export const dacGeneralParamsSchema = z.object({
  dynaDocsModelIds: z
    .array(z.number())
    .min(1, 'Au moins un modèle de documents est requis'),
});

export const paramGeneralFieldSchema = z.object({
  paramGeneralName: z.string({ required_error: 'Le nom est requis' }).min(1, 'Le nom est requis'),
  paramGeneralLabel: z.string({ required_error: 'Le libellé est requis' }).min(1, 'Le libellé est requis'),
  paramGeneralType: z.string({ required_error: 'Le type est requis' }).min(1, 'Le type est requis'),
  paramGeneralOrder: z.number({ required_error: "L'ordre est requis" }),
  paramGeneralStatus: z.string({ required_error: 'Le statut est requis' }).min(1, 'Le statut est requis'),
});

export const paramGeneralBaseSchema = z.object({
  paramGeneralName: z.string({ required_error: 'Le nom est requis' }).min(1, 'Le nom est requis'),
  paramGeneralLabel: z.string({ required_error: 'Le libellé est requis' }).min(1, 'Le libellé est requis'),
  paramGeneralType: z.string({ required_error: 'Le type est requis' }).min(1, 'Le type est requis'),
  paramGeneralOrder: z.number({ required_error: "L'ordre est requis" }),
});
